import React from 'react';
import clsx from 'clsx';

type Tone = 'neutral' | 'primary' | 'success' | 'warning' | 'danger' | 'info';

interface Props {
  tone?: Tone;
  children: React.ReactNode;
  className?: string;
  title?: string;
}

export function Badge({ tone = 'neutral', children, className, title }: Props) {
  return (
    <span className={clsx('badge', `badge-${tone}`, className)} title={title}>
      {children}
    </span>
  );
}
